'use strict';

angular.module('clientDashboardApp').directive('deepLink', function ($location) {
    return {
        restrict: 'A',
        transclude: true,
        scope: {
            deepLinkParams: '=deepLink'
        },
        template: '<a ng-href="{{deepUrl}}" ng-transclude></a>',
        link: function (scope) {
            var urlWithParam = function (newParams) {
                //To save building URL and encoding params from scratch.
                //Update angular search params, grab url and then reset.
                var urlBefore = $location.url();
                var newSearchParams = angular.extend($location.search(), newParams);
                $location.search(newSearchParams);
                var newUrl = $location.absUrl();
                $location.url(urlBefore);
                return newUrl;
            };

            scope.deepUrl = urlWithParam(scope.deepLinkParams)
        }
    };
});
